export default __webpack_public_path__ + "static/media/hht1_ep14_minisitcom_01.95c06961.png";